var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA0Dashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.75 58.583h-9.5a3.176 3.176 0 01-3.167-3.166V20.583a3.176 3.176 0 013.167-3.166h9.5a3.176 3.176 0 013.167 3.166v34.834a3.176 3.176 0 01-3.167 3.166zm19 0h-9.5a3.176 3.176 0 01-3.167-3.166V42.75a3.176 3.176 0 013.167-3.167h9.5a3.176 3.176 0 013.167 3.167v12.667a3.176 3.176 0 01-3.167 3.166zm9.5 0h9.5a3.176 3.176 0 003.167-3.166V42.75a3.176 3.176 0 00-3.167-3.167h-9.5a3.176 3.176 0 00-3.167 3.167v12.667a3.176 3.176 0 003.167 3.166zM30.083 33.25V20.583a3.176 3.176 0 013.167-3.166h28.5a3.176 3.176 0 013.167 3.166V33.25a3.176 3.176 0 01-3.167 3.167h-28.5a3.176 3.176 0 01-3.167-3.167z"
  })));
}
export default __webpack_public_path__ + "static/media/A0_dashboard.91ab8f24.svg";
export { SvgA0Dashboard as ReactComponent };